import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("azerbaijan",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 4.5L0 4.5L0 20.5L24 20.5L24 4.5Z"
                fill="#509E2F" />
            <path
                d="M24 4.5L0 4.5L0 15.1667L24 15.1667V4.5Z"
                fill="#EF3340" />
            <path
                d="M24 4.5L0 4.5L0 9.83333L24 9.83333V4.5Z"
                fill="#00B5E2" />
            <path
                d="M11.5972 14.8994C12.5914 14.8994 13.3974 13.8247 13.3974 12.499C13.3974 11.1733 12.5914 10.0986 11.5972 10.0986C10.6029 10.0986 9.79688 11.1733 9.79688 12.499C9.79688 13.8247 10.6029 14.8994 11.5972 14.8994Z"
                fill="white" />
            <path
                d="M11.9997 14.4992C12.828 14.4992 13.4994 13.604 13.4994 12.4996C13.4994 11.3953 12.828 10.5 11.9997 10.5C11.1714 10.5 10.5 11.3953 10.5 12.4996C10.5 13.604 11.1714 14.4992 11.9997 14.4992Z"
                fill="#ED2939" />
            <path
                d="M13.6014 11.167L13.7928 11.8842L14.3085 11.5572L14.0633 12.2448L14.6012 12.5001L14.0633 12.7553L14.3085 13.4429L13.7928 13.116L13.6014 13.8331L13.4099 13.116L12.8942 13.4429L13.1394 12.7553L12.6016 12.5001L13.1394 12.2448L12.8942 11.5572L13.4099 11.8842L13.6014 11.167Z"
                fill="white" />
        </svg>
    `),e=i("azerbaijan_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_85954)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M36 0.5L-12 0.5L-12 24.5L36 24.5L36 0.5Z"
                    fill="#509E2F" />
                <path
                    d="M36 0.5L-12 0.5L-12 16.5L36 16.5V0.5Z"
                    fill="#EF3340" />
                <path
                    d="M36 0.5L-12 0.5L-12 8.5L36 8.5V0.5Z"
                    fill="#00B5E2" />
                <path
                    d="M11.1982 16.0995C13.1867 16.0995 14.7988 14.4875 14.7988 12.499C14.7988 10.5105 13.1867 8.89844 11.1982 8.89844C9.20968 8.89844 7.59766 10.5105 7.59766 12.499C7.59766 14.4875 9.20968 16.0995 11.1982 16.0995Z"
                    fill="white" />
                <path
                    d="M11.9994 15.4988C13.6559 15.4988 14.9988 14.1559 14.9988 12.4994C14.9988 10.8429 13.6559 9.5 11.9994 9.5C10.3429 9.5 9 10.8429 9 12.4994C9 14.1559 10.3429 15.4988 11.9994 15.4988Z"
                    fill="#ED2939" />
                <path
                    d="M15.1988 10.5L15.5817 11.5757L16.6131 11.0853L16.1227 12.1168L17.1984 12.4996L16.1227 12.8824L16.6131 13.9139L15.5817 13.4235L15.1988 14.4992L14.816 13.4235L13.7845 13.9139L14.275 12.8824L13.1992 12.4996L14.275 12.1168L13.7845 11.0853L14.816 11.5757L15.1988 10.5Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19470_85954">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Azerbaijan,e as AzerbaijanRounded};
